export default function CTASection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto text-center">
        {/* Image */}
        <div className="relative w-full max-w-[800px] mx-auto h-56 md:h-72 rounded-3xl overflow-hidden mb-14">
          <img
            src="https://readdy.ai/api/search-image?query=Beautifully%20styled%20flat%20lay%20of%20various%20fashion%20accessories%20including%20a%20leather%20watch%20strap%2C%20minimalist%20sunglasses%20and%20a%20small%20potted%20succulent%20on%20a%20light%20cream%20linen%20surface%2C%20warm%20afternoon%20sunlight%20from%20a%20window%2C%20elegant%20lifestyle%20photography%20with%20soft%20shadows%20and%20organic%20relaxed%20composition&width=1200&height=600&seq=cta-v2-029&orientation=landscape"
            alt="Kakobuy Spreadsheet Product Collection"
            title="Explore Kakobuy Spreadsheet Collection"
            className="w-full h-full object-cover object-top"
          />
        </div>

        {/* Text */}
        <h2 className="text-foreground-950 text-3xl md:text-4xl lg:text-5xl font-bold font-heading leading-[1.2] mb-4">
          Ready to Explore
        </h2>
        <p className="text-foreground-400 text-3xl md:text-4xl lg:text-5xl font-light italic font-heading leading-[1.2] mb-4">
          the Latest
        </p>
        <h2 className="text-foreground-950 text-3xl md:text-4xl lg:text-5xl font-bold font-heading leading-[1.2] mb-12">
          Kakobuy Spreadsheet?
        </h2>

        {/* CTA Button */}
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 h-15 px-10 bg-primary-500 text-background-50 rounded-full font-semibold text-base hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          View Spreadsheet
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-lg"></i>
          </span>
        </a>
      </div>
    </section>
  );
}